<div class="custom-announcements-container">
  <app-templates></app-templates>
  <app-announcements></app-announcements>
</div> 